var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 17.375H4.125C3.08946 17.375 2.25 16.5355 2.25 15.5L2.25005 4.62499C2.25006 3.58946 3.08952 2.75 4.12505 2.75H13.125C14.1605 2.75 15 3.58947 15 4.625V6.5H19.875C20.9105 6.5 21.75 7.33947 21.75 8.375V20.375C21.75 21.4105 20.9105 22.25 19.875 22.25H9.375C8.33947 22.25 7.5 21.4105 7.5 20.375V17.375ZM4.5 15.125L4.50005 5H12.75V6.5H9.375C8.33947 6.5 7.5 7.33947 7.5 8.375V15.125H4.5ZM9.75 20V8.75H19.5V20H9.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.dc50d354cd2ca0195cb14c1c231e667f.svg";
export { ForwardRef as ReactComponent };